import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";
import {SirenDefaultDeliveryMethods} from "./useGetSirenDefaultDeliveryMethods";
import {useEvents} from "../../../lib/useEvents";

export type SirenDefaultDeliveryMethodsInput = {
    clientID?: string;
    departmentID?: string;
    deliveryMethods: string[];
};

export function useUpsertSirenDefaultDeliveryMethods() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const save = useCallback(async (input: SirenDefaultDeliveryMethodsInput): Promise<SirenDefaultDeliveryMethods> => {
        setSaving(true);
        setError(null);
        try {
            const res = await platformAPI.post<SirenDefaultDeliveryMethods>("api/siren/default-delivery-methods", input);
            emit("siren:deliveryMethods:changed", {clientID: input.clientID, departmentID: input.departmentID});
            return res.data;
        } catch (e) {
            if (isAxiosError(e) && e?.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("Failed to save default delivery methods");
            }
            throw e;
        } finally {
            setSaving(false);
        }
    }, []);

    return {save, saving, error};
}
